import { format } from "date-fns";
import useUserConsents from "../hooks/use-user-consents";
import { ConsentPurpose } from "../services/get-user-consents";

const PURPOSE_LABELS: Record<ConsentPurpose, string> = {
  MARKETING: "Marketing",
  ANALYTICS: "Analytics",
  ADVERTISING: "Ads",
};

/**
 * DPDP consent per optional purpose (RH-1093). A withdrawn marketing consent
 * means the care team must not contact this person for offers or nudges.
 * Unanswered purposes are hidden: most existing users have none yet.
 */
export function UserConsentCapsules({
  userId,
  capsuleClass,
}: {
  userId: string;
  capsuleClass: string;
}) {
  const { data } = useUserConsents(userId);
  if (!data) return null;

  return (
    <>
      {data.purposes
        .filter((p) => p.granted !== null)
        .map((p) => {
          const label = PURPOSE_LABELS[p.purpose] ?? p.purpose;
          const when = p.given_at
            ? format(new Date(p.given_at), "d MMM yyyy")
            : "";
          return (
            <span
              key={p.purpose}
              title={`${p.granted ? "Consented" : "Withdrawn / declined"} on ${when} under policy ${p.policy_version} (${p.source})`}
              className={`${capsuleClass} ${
                p.granted
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              {label}: {p.granted ? "Consented" : "No consent"}
            </span>
          );
        })}
    </>
  );
}
